import type { OktaConfig } from '@LaSalle-invest/okta-mfe-auth/react';

// Environment-based configuration
const OKTA_ISSUER = import.meta.env.VITE_OKTA_ISSUER || 'https://applogin-uat.jll.com/oauth2/default';
const OKTA_CLIENT_ID = import.meta.env.VITE_OKTA_CLIENT_ID || '';

// Configuration constants
export const AUTH_CONSTANTS = {
  ISSUER: OKTA_ISSUER,
  CLIENT_ID: OKTA_CLIENT_ID,
  SCOPES: ['openid', 'profile', 'email', 'offline_access'] as string[],
  CALLBACK_PATH: '/login/callback',
  TOKEN_STORAGE_KEY: 'okta-token-storage',
  TOKEN_AUTO_RENEW: true,
  TOKEN_AUTO_REMOVE: true,
  SECURE_COOKIES: window.location.protocol === 'https:',
  CACHE_DURATION: 300, // 5 minutes
  MAX_CLOCK_SKEW: 300, // 5 minutes

  // Additional constants for better error handling
  MAX_RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
  TOKEN_REFRESH_THRESHOLD: 300000, // 5 minutes in milliseconds
  AUTH_CHECK_CACHE_DURATION: 60000, // 1 minute in milliseconds
  LOGIN_TIMEOUT: 10000, // 10 seconds
  MAX_REDIRECT_ATTEMPTS: 3,
} as const;

// Error types for better error handling
export const AUTH_ERRORS = {
  TIMEOUT: 'AUTH_TIMEOUT',
  NETWORK: 'AUTH_NETWORK_ERROR',
  TOKEN_EXPIRED: 'AUTH_TOKEN_EXPIRED',
  TOKEN_INVALID: 'AUTH_TOKEN_INVALID',
  POPUP_BLOCKED: 'AUTH_POPUP_BLOCKED',
  CSP_ERROR: 'AUTH_CSP_ERROR',
  CALLBACK_ERROR: 'AUTH_CALLBACK_ERROR',
  CONFIG_ERROR: 'AUTH_CONFIG_ERROR',
  UNKNOWN: 'AUTH_UNKNOWN_ERROR',
} as const;

export type AuthErrorType = keyof typeof AUTH_ERRORS;

const oktaConfig = {
  issuer: AUTH_CONSTANTS.ISSUER,
  clientId: AUTH_CONSTANTS.CLIENT_ID,
  redirectUri: `${window.location.origin}${AUTH_CONSTANTS.CALLBACK_PATH}`,
  scopes: AUTH_CONSTANTS.SCOPES,
  pkce: true,
  postLogoutRedirectUri: `${window.location.origin}/`,
  onError: (err: Error) => {
    if (import.meta.env.DEV) {
      console.error('Okta auth error:', err);
    }
  },
} satisfies OktaConfig;

export default oktaConfig;
